import React, { useState } from "react";
import "./Contact.css";
// import emailIcon from "./emailIcon.png";
import linkedInIcon from "./linkedInIcon.png";
import githubIcon from "./githubIcon.png";
import axios from "axios";
function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      name,
      email,
      subject,
      message,
    };

    try {
      // Send the data to the server for email processing
      console.log(data)
      const response = await axios.post(
        "https://portfolio-gubk.onrender.com/send-email",
        data
      );
      console.log(response.data); // Assuming the server sends a response message
      // Reset form fields
      setName("");
      setEmail("");
      setSubject("");
      setMessage("");

      alert('Successfully sent the email');
    } catch (error) {
      console.error(error);
       alert('error');
      // Handle any error that occurs during the request
    }
  };
  return (
    <div className="contact ">
      <h2 className="text-center my-5 fw-light" style={{ color: "navy" }}>
        Contact Us
      </h2>
      <div className="contactInfo container d-flex">
        <div className=" text-center" style={{ flex: "1" }}>
          <span className="fw-bold display-6 p-2">
            Let's chat <br /> Tell me about your project.
          </span>
          <br />
          <span className="text-muted my-3">
            Lets create something together
          </span>{" "}
          <br />
          <div className="d-flex flex-column p-2">
            <div className="my-3">
              <a href="mailto:anandamrit309@gmail.com">
                {" "}
                <img
                  src="https://ssl.gstatic.com/ui/v1/icons/mail/rfr/logo_gmail_lockup_default_1x_r5.png"
                  alt=""
                  // style={{
                  //   height: "60px",
                  //   width: "140px",
                  // }}
                />
              </a>
            </div>
            <div className="my-3">
              <img src="" alt="" />
              <a href="https://www.linkedin.com/in/amadawni/" target="_blank">
                <img
                  src={linkedInIcon}
                  alt=""
                  style={{
                    height: "60px",
                    width: "60px",
                  }}
                />
              </a>
            </div>
            <div className="my-3">
              <a href="https://github.com/amadawni" target="_blank">
                <img
                  src={githubIcon}
                  alt=""
                  style={{
                    height: "60px",
                    width: "60px",
                  }}
                />
              </a>
            </div>
          </div>
        </div>
        <div style={{ flex: "1" }}>
          <div className="container">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  id="name"
                  className="form-control"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Full Name"
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email Address"
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  id="subject"
                  className="form-control"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  placeholder="Subject"
                />
              </div>
              <div className="form-group">
                <textarea
                  id="message"
                  className="form-control"
                  rows="5"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Complete Message"
                ></textarea>
              </div>
              <div className="text-center my-4">
                <button type="submit" className="btn btn-primary ">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
